export default __webpack_public_path__ + "static/media/search-hover.afb241dd.svg";